import { Grid, styled, Typography } from "@mui/material";

export const ItemBox = styled(Grid)({
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  alignItems: "center",
  marginTop: "5px",
  justifyContent: "space-between",
  padding: "0px 20px",
});

export const Title = styled(Typography)({
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "16px",
  marginRight: "5px",
  color: "#4eaf51",
});
